var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRclogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 38,
    viewBox: "0 0 4636 977",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M713.801 118.474C564.906 133.325 484.018 216.57 425.81 304.537L390.613 357.728L234.001 213.744L307.657 134.04L372.265 193.44C440.428 107.736 541.012 26.7704 702.987 10.6144L713.801 118.474Z",
    fill: "url(#paint0_linear_420_53)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M910.328 384.962C794.589 290.448 678.452 292.262 574.996 313.411L512.44 326.199L503.779 113.927L612.296 109.517L615.869 197.087C724.755 184.56 853.195 198.249 979.102 301.066L910.328 384.962Z",
    fill: "url(#paint1_linear_420_53)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.506 264.946C133.396 413.458 216.855 494.139 305.049 552.197L358.377 587.303L214.022 743.513L134.113 670.047L193.665 605.604C107.741 537.616 26.5669 437.291 10.3693 275.732L118.506 264.946Z",
    fill: "url(#paint2_linear_420_53)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M385.565 68.6195C290.839 184.099 292.656 299.975 313.853 403.198L326.67 465.614L113.921 474.256L109.5 365.983L197.268 362.418C184.712 253.776 198.433 125.624 301.481 0L385.565 68.6195Z",
    fill: "url(#paint3_linear_420_53)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.408 858.695C414.303 843.844 495.191 760.599 553.4 672.631L588.596 619.44L745.208 763.425L671.553 843.128L606.944 783.729C538.781 869.433 438.198 950.398 276.222 966.554L265.408 858.695Z",
    fill: "url(#paint4_linear_420_53)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.7963 592.342C184.573 686.825 300.747 685.012 404.237 663.87L466.813 651.086L475.477 863.288L366.925 867.698L363.351 780.155C254.429 792.679 125.948 778.994 0 676.21L68.7963 592.342Z",
    fill: "url(#paint5_linear_420_53)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M860.703 712.054C845.813 563.542 762.354 482.861 674.16 424.803L620.832 389.697L765.187 233.487L845.096 306.953L785.544 371.396C871.468 439.384 952.642 539.709 968.84 701.268L860.703 712.054Z",
    fill: "url(#paint6_linear_420_53)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M593.644 908.38C688.371 792.901 686.553 677.025 665.357 573.802L652.54 511.386L865.289 502.744L869.709 611.017L781.942 614.582C794.497 723.224 780.777 851.376 677.729 977L593.644 908.38Z",
    fill: "url(#paint7_linear_420_53)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1402.77 637.176L1319.15 497.954H1256.89V637.176H1175.05V236.124H1341.09C1379.44 236.124 1412.06 249.11 1438.94 275.083C1465.82 301.056 1479.26 332.376 1479.26 369.044C1479.26 393.871 1471.95 416.979 1457.32 438.369C1442.69 459.376 1423.32 475.227 1399.21 485.922L1491.12 637.176H1402.77ZM1256.89 310.032V428.629H1341.09C1356.51 428.629 1369.76 422.9 1380.82 411.441C1391.89 399.6 1397.43 385.468 1397.43 369.044C1397.43 352.62 1391.89 338.679 1380.82 327.22C1369.76 315.761 1356.51 310.032 1341.09 310.032H1256.89Z",
    fill: "#0E1328"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1728.24 350.71H1804.74V637.176H1728.24V603.373C1705.32 631.256 1673.1 645.197 1631.59 645.197C1592.05 645.197 1558.05 630.683 1529.59 601.654C1501.52 572.244 1487.49 536.34 1487.49 493.943C1487.49 451.546 1501.52 415.833 1529.59 386.805C1558.05 357.394 1592.05 342.689 1631.59 342.689C1673.1 342.689 1705.32 356.631 1728.24 384.513V350.71ZM1587.11 552.382C1602.53 567.278 1622.1 574.726 1645.82 574.726C1669.54 574.726 1689.11 567.278 1704.52 552.382C1720.34 537.104 1728.24 517.624 1728.24 493.943C1728.24 470.262 1720.34 450.973 1704.52 436.077C1689.11 420.799 1669.54 413.16 1645.82 413.16C1622.1 413.16 1602.53 420.799 1587.11 436.077C1571.69 450.973 1563.98 470.262 1563.98 493.943C1563.98 517.624 1571.69 537.104 1587.11 552.382Z",
    fill: "#0E1328"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M2028.88 342.689C2068.81 342.689 2102.81 357.394 2130.88 386.805C2159.34 415.833 2173.58 451.546 2173.58 493.943C2173.58 536.34 2159.34 572.244 2130.88 601.654C2102.81 630.683 2068.81 645.197 2028.88 645.197C1987.37 645.197 1955.35 631.256 1932.82 603.373V751.762H1856.32V350.71H1932.82V384.513C1955.35 356.631 1987.37 342.689 2028.88 342.689ZM1955.94 552.382C1971.36 567.278 1990.93 574.726 2014.65 574.726C2038.37 574.726 2057.94 567.278 2073.36 552.382C2089.17 537.104 2097.08 517.624 2097.08 493.943C2097.08 470.262 2089.17 450.973 2073.36 436.077C2057.94 420.799 2038.37 413.16 2014.65 413.16C1990.93 413.16 1971.36 420.799 1955.94 436.077C1940.53 450.973 1932.82 470.262 1932.82 493.943C1932.82 517.624 1940.53 537.104 1955.94 552.382Z",
    fill: "#0E1328"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M2247.69 316.334C2235.04 316.334 2223.97 311.942 2214.48 303.157C2205.39 293.99 2200.84 283.295 2200.84 271.073C2200.84 258.85 2205.39 248.156 2214.48 238.989C2223.97 229.822 2235.04 225.238 2247.69 225.238C2260.73 225.238 2271.8 229.822 2280.89 238.989C2290.38 248.156 2295.13 258.85 2295.13 271.073C2295.13 283.295 2290.38 293.99 2280.89 303.157C2271.8 311.942 2260.73 316.334 2247.69 316.334ZM2209.73 637.176V350.71H2286.23V637.176H2209.73Z",
    fill: "#0E1328"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M2563.2 236.124H2639.7V637.176H2563.2V603.373C2540.67 631.256 2508.65 645.197 2467.14 645.197C2427.21 645.197 2393.01 630.683 2364.55 601.654C2336.48 572.244 2322.45 536.34 2322.45 493.943C2322.45 451.546 2336.48 415.833 2364.55 386.805C2393.01 357.394 2427.21 342.689 2467.14 342.689C2508.65 342.689 2540.67 356.631 2563.2 384.513V236.124ZM2422.07 552.382C2437.88 567.278 2457.65 574.726 2481.37 574.726C2505.09 574.726 2524.66 567.278 2540.08 552.382C2555.5 537.104 2563.2 517.624 2563.2 493.943C2563.2 470.262 2555.5 450.973 2540.08 436.077C2524.66 420.799 2505.09 413.16 2481.37 413.16C2457.65 413.16 2437.88 420.799 2422.07 436.077C2406.65 450.973 2398.94 470.262 2398.94 493.943C2398.94 517.624 2406.65 537.104 2422.07 552.382Z",
    fill: "#0E1328"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M2892.31 645.197C2829.84 645.197 2778.25 625.144 2737.53 585.039C2696.81 544.934 2676.45 495.471 2676.45 436.65C2676.45 377.447 2696.81 327.984 2737.53 288.261C2778.25 248.156 2829.84 228.103 2892.31 228.103C2929.86 228.103 2964.45 236.697 2996.08 253.885C3028.1 270.691 3053.01 293.608 3070.8 322.637L3000.23 362.169C2989.95 344.217 2975.33 330.276 2956.35 320.345C2937.37 310.032 2916.03 304.876 2892.31 304.876C2851.98 304.876 2819.37 317.098 2794.46 341.543C2769.95 365.988 2757.7 397.691 2757.7 436.65C2757.7 475.227 2769.95 506.739 2794.46 531.184C2819.37 555.629 2851.98 567.851 2892.31 567.851C2916.03 567.851 2937.37 562.886 2956.35 552.955C2975.72 542.642 2990.35 528.701 3000.23 511.131L3070.8 550.663C3053.01 579.692 3028.3 602.8 2996.67 619.988C2965.05 636.794 2930.26 645.197 2892.31 645.197Z",
    fill: "#0E1328"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M3326.8 350.71H3403.3V637.176H3326.8V603.373C3303.87 631.256 3271.65 645.197 3230.14 645.197C3190.61 645.197 3156.61 630.683 3128.15 601.654C3100.08 572.244 3086.04 536.34 3086.04 493.943C3086.04 451.546 3100.08 415.833 3128.15 386.805C3156.61 357.394 3190.61 342.689 3230.14 342.689C3271.65 342.689 3303.87 356.631 3326.8 384.513V350.71ZM3185.67 552.382C3201.08 567.278 3220.65 574.726 3244.37 574.726C3268.09 574.726 3287.66 567.278 3303.08 552.382C3318.89 537.104 3326.8 517.624 3326.8 493.943C3326.8 470.262 3318.89 450.973 3303.08 436.077C3287.66 420.799 3268.09 413.16 3244.37 413.16C3220.65 413.16 3201.08 420.799 3185.67 436.077C3170.25 450.973 3162.54 470.262 3162.54 493.943C3162.54 517.624 3170.25 537.104 3185.67 552.382Z",
    fill: "#0E1328"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M3619.73 342.689C3652.15 342.689 3678.83 353.193 3699.78 374.2C3721.13 395.208 3731.81 424.236 3731.81 461.286V637.176H3655.31V470.453C3655.31 451.355 3649.97 436.841 3639.3 426.91C3628.62 416.597 3614.39 411.441 3596.6 411.441C3576.84 411.441 3561.02 417.361 3549.16 429.202C3537.3 441.042 3531.37 458.803 3531.37 482.484V637.176H3454.87V350.71H3531.37V382.794C3549.95 356.058 3579.41 342.689 3619.73 342.689Z",
    fill: "#0E1328"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M3969.22 350.71H4053.43L3940.76 637.176H3853.58L3740.91 350.71H3825.12L3896.87 551.236L3969.22 350.71Z",
    fill: "#0E1328"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M4286.28 350.71H4362.78V637.176H4286.28V603.373C4263.35 631.256 4231.13 645.197 4189.62 645.197C4150.09 645.197 4116.09 630.683 4087.63 601.654C4059.56 572.244 4045.52 536.34 4045.52 493.943C4045.52 451.546 4059.56 415.833 4087.63 386.805C4116.09 357.394 4150.09 342.689 4189.62 342.689C4231.13 342.689 4263.35 356.631 4286.28 384.513V350.71ZM4145.15 552.382C4160.56 567.278 4180.13 574.726 4203.85 574.726C4227.57 574.726 4247.14 567.278 4262.56 552.382C4278.37 537.104 4286.28 517.624 4286.28 493.943C4286.28 470.262 4278.37 450.973 4262.56 436.077C4247.14 420.799 4227.57 413.16 4203.85 413.16C4180.13 413.16 4160.56 420.799 4145.15 436.077C4129.73 450.973 4122.02 470.262 4122.02 493.943C4122.02 517.624 4129.73 537.104 4145.15 552.382Z",
    fill: "#0E1328"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M4482.61 432.067C4482.61 439.706 4487.75 446.008 4498.02 450.973C4508.7 455.557 4521.55 459.758 4536.57 463.578C4551.59 467.015 4566.61 471.599 4581.64 477.328C4596.66 482.675 4609.31 491.842 4619.59 504.829C4630.26 517.815 4635.6 534.048 4635.6 553.528C4635.6 582.938 4624.14 605.665 4601.21 621.707C4578.67 637.367 4550.41 645.197 4516.41 645.197C4455.53 645.197 4414.02 622.471 4391.88 577.018L4458.29 540.923C4466.99 565.75 4486.36 578.164 4516.41 578.164C4543.69 578.164 4557.32 569.952 4557.32 553.528C4557.32 545.889 4551.99 539.778 4541.31 535.194C4531.03 530.229 4518.38 525.836 4503.36 522.017C4488.34 518.197 4473.32 513.423 4458.29 507.693C4443.27 501.964 4430.42 492.988 4419.75 480.766C4409.47 468.161 4404.33 452.501 4404.33 433.785C4404.33 405.521 4415 383.367 4436.35 367.325C4458.1 350.901 4484.98 342.689 4517 342.689C4541.12 342.689 4563.06 348.037 4582.82 358.731C4602.59 369.044 4618.21 383.94 4629.67 403.42L4564.44 437.796C4554.95 418.316 4539.14 408.576 4517 408.576C4507.12 408.576 4498.82 410.677 4492.09 414.879C4485.77 419.08 4482.61 424.809 4482.61 432.067Z",
    fill: "#0E1328"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_420_53",
    x1: 77.734,
    y1: 286.754,
    x2: 979.113,
    y2: 649.265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD9DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_420_53",
    x1: 77.734,
    y1: 286.754,
    x2: 979.113,
    y2: 649.265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD9DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_420_53",
    x1: 77.734,
    y1: 286.754,
    x2: 979.113,
    y2: 649.265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD9DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_420_53",
    x1: 77.734,
    y1: 286.754,
    x2: 979.113,
    y2: 649.265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD9DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_420_53",
    x1: 77.734,
    y1: 286.754,
    x2: 979.113,
    y2: 649.265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD9DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_420_53",
    x1: 77.734,
    y1: 286.754,
    x2: 979.113,
    y2: 649.265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD9DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_420_53",
    x1: 77.734,
    y1: 286.754,
    x2: 979.113,
    y2: 649.265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD9DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_420_53",
    x1: 77.734,
    y1: 286.754,
    x2: 979.113,
    y2: 649.265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD9DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5C00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRclogo);
export default __webpack_public_path__ + "static/media/rclogo.a494ca4aa407916449f19c41f63e3686.svg";
export { ForwardRef as ReactComponent };